import { Component, HostListener, computed, input, output, signal } from '@angular/core';
import { QuestionarioPergunta } from '../../core/models/questionario-form.model';

@Component({
  selector: 'app-selecionar-pergunta-modal',
  standalone: true,
  imports: [],
  templateUrl: './selecionar-pergunta-modal.component.html',
  styleUrl: './selecionar-pergunta-modal.component.scss',
})
export class SelecionarPerguntaModalComponent {
  readonly perguntas = input.required<QuestionarioPergunta[]>();
  readonly carregando = input(false);

  readonly selecionar = output<QuestionarioPergunta>();
  readonly fechar = output<void>();

  readonly filtro = signal('');

  readonly perguntasFiltradas = computed(() => {
    const termo = this.filtro().trim().toLowerCase();
    if (!termo) {
      return this.perguntas();
    }
    return this.perguntas().filter((pergunta) => pergunta.texto.toLowerCase().includes(termo));
  });

  onFiltroChange(valor: string): void {
    this.filtro.set(valor);
  }

  onFechar(): void {
    this.fechar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}
